module.exports = __webpack_public_path__ + "static/media/module6.d896913d.png";